import type { ReactNode } from 'react'

export function ProfileField({
  label,
  value,
  badge,
}: {
  label: string
  value: string
  badge?: ReactNode
}) {
  return (
    <div className="flex min-w-0 flex-col gap-0.5">
      <dt className="text-caption uppercase tracking-wide text-muted-foreground">{label}</dt>
      <dd className="break-words text-body-sm text-foreground">{badge ?? value}</dd>
    </div>
  )
}
